import React, { memo, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import styled from 'styled-components';

import { MobileIconButton } from '../MobileIconButton';

interface ITouchCardFrameProps {
  onClose: () => void;
  children: ReactNode;
}

/**
 * ТЗ 0121 — карточка-поповер на сенсорном экране: сверху справа видимый
 * крестик. Наведения нет, «увести мышь» нельзя — закрыть можно нажатием мимо
 * или этой кнопкой. Используют `HoverCard` и `StudentHoverCard`.
 */
export const TouchCardFrame = memo(
  ({ onClose, children }: ITouchCardFrameProps) => {
    const { t } = useTranslation();
    return (
      <Frame>
        <CloseRow>
          <MobileIconButton
            icon={X}
            onClick={onClose}
            aria-label={t('button.close')}
          />
        </CloseRow>
        {children}
      </Frame>
    );
  },
);

TouchCardFrame.displayName = 'TouchCardFrame';

const Frame = styled.div`
  max-width: calc(100vw - 48px);
`;

const CloseRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: -8px -8px 0 0;
`;
